export default __webpack_public_path__ + "static/media/Vector.d580f753.svg";